import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import {
  event_detail_action,
  event_add_action,
} from "../../../actions/master_actions/events_action";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../utils/Loader";
import Header from "../../../common_components/Header";
import { sessionExpireMessage, tokenInavlidMessage } from "../../../utils/constants";

class EventsAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isOpen: false,
      userId: "",
      TypeOfEventID: "",
      StatusID: "",
      Name: "",
      Code: "",
      StatusID: "",
      eventList: [],
      NameErr:""
    };
    this.navigateBackEvent = this.navigateBackEvent.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.eventDetails = this.eventDetails.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.clearFields = this.clearFields.bind(this);
  }
  componentDidMount() {
    console.log(this.props.location);
    if (JSON.parse(sessionStorage.getItem("UserLoginData")) == null) {
      console.log("log");
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }
    setTimeout(() => {
      {
        sessionStorage.getItem("roleId") == 4 ? (
          this.props.navigate("/checkList")
        ) : (
          <></>
        );
      }
    }, 10);
    const { userId, Status } = this.state;
    this.setState({
      userId:
        sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
      StatusID: this.props.location.state?.StatusID
        ? this.props.location.state?.StatusID
        : "",
    });
    console.log(this.props.location.state);
    const TypeOfEventID = this.props.location.state?.TypeOfEventID || "";
    if (TypeOfEventID) {
      this.setState({ TypeOfEventID }, () => {
        this.eventDetails();
      });
    } else {
      this.setState({
        Code: this.props.location.state?.Code
          ? this.props.location.state?.Code
          : "",
      });
      this.clearFields();
    }
  }

  clearFields() {
    this.setState({
      TypeOfEventID: "",
      Name: "",
      Code: "",
      StatusID: 0,
    });
  }

  navigateBackEvent() {
    this.props.navigate("/events");
  }
  eventDetails() {
    const { userId, TypeOfEventID } = this.state;
    if (TypeOfEventID) {
      this.props
        .event_detail_action(TypeOfEventID)
        .then((data) => {
          console.log("event details--------", data);
          if (data.error !== 1) {
            this.setState({
              Name: data.data[0]["Name"],
              Code: data.data[0]["Code"],
              StatusID: data.data[0]["StatusID"],
            });
          } else {
            if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
              //after session expire.....................
              sessionStorage.clear()
              this.props.navigate('/normalView')
              setTimeout(() => {
                toast.error(data.msg, {
                  position:"top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
          }else{
            toast.error(data.data, {
              position:"top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }}
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }

  handleInputChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }
  inputValidate(){
    const {Name}=this.state
    if(Name===""){
      this.setState({NameErr:'Please enter Event Name'})
    }
  }
  handleSubmit() {
    var { userId, TypeOfEventID, Name, Code, StatusID } = this.state;
    setTimeout(() => {
      this.inputValidate()
  }, 100);
    if (Name == "") {
      this.setState({ isLoading: false },()=>{
        toast.error("Event Name cannot be blank", {
          position:"top-center",
          theme: "colored",
          autoClose: 3000,
          hideProgressBar: true,
        });
      });
    
    } else {
      this.setState({ isLoading: true });
      var Code=Code?Code:this.props.location.state.Code
      const finalStatus = StatusID ? 1 : 0; // Convert checkbox value to 1 or 0
      // Update operation
      this.props
        .event_add_action(TypeOfEventID, Name, Code, finalStatus)
        .then((data) => {
          console.log(data, "update");
          if (data.error !== 1) {
            this.setState({ isLoading: false },()=>{
              toast.success(
                TypeOfEventID?'Updated Successfully':'Submitted Successfully',
                {
                  position:"top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                }
              );
              setTimeout(() => {
                this.props.navigate("/events");
              }, 1000); // Adjust the delay time as needed
            });
          } else {
            console.log("else case",data);
            if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
              //after session expire.....................
              sessionStorage.clear()
              this.props.navigate('/normalView')
              setTimeout(() => {
                toast.error(data.msg, {
                  position:"top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
          }else{
            toast.error(data.msg, {
              position:"top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
           
            this.setState({ isLoading: false });
           
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }
  render() {
    const { TypeOfEventID, Name, Code, StatusID, isLoading ,NameErr} = this.state;
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">
            <Header data={[21]} />
            <div className="container-fluid">
              <section style={{ marginTop: 115 }}>
                <div className="page-header">
                  <h4 className="page-title">
                    {TypeOfEventID ? "Edit" : "Add"} Event
                  </h4>
                  <div className="Service_display pt-2">
                    <h6 className="Services_Active_or_Not">{TypeOfEventID?StatusID == 1 ? "Active" : "Inactive":"Active"}</h6>
                    <div className="checkbox checbox-switch">
                      <label className="switch">
                      {TypeOfEventID?(
                             <>
                         
                             <input
                               type="checkbox"
                               checked={StatusID}
                               onChange={() => {
                                 this.setState((prevState) => ({
                                   StatusID: !prevState.StatusID,
                                 }));
                               }}
                             />
                             <span class="slider round"></span>
                             </>

                        ):(
                          <>
                          <input
                                                    type="checkbox"
                                                    checked={1}
                                                   
                                                  />
                                                  <span class="slider round"></span></>
                        )}
                      </label>
                    </div>
                  </div>
                </div>
              </section>
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="form-group col-md-3 mb-3">
                      <label htmlFor="inputZip">
                        Event Code <span className="mendatory_class">*</span>{" "}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="fname"
                        name="name"
                        value={
                          this.state.Code
                            ? this.state.Code
                            : this.props.location.state.Code
                        }
                        disabled
                        // onChange={(e) =>
                        //   this.setState({ Code: e.target.value })
                        // }
                      />
                    </div>
                    <div className="form-group col-md-3 mb-3">
                      <label htmlFor="inputZip">
                        Event Name <span className="mendatory_class">*</span>{" "}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        maxLength={50}
                        id="fname"
                        name="name"
                        value={this.state.Name}
                        onChange={(e) =>
                          this.setState({ Name: e.target.value,NameErr:'' })
                        }
                      />{<span className='text-danger text-start text-left d-block mt-1'>{NameErr}</span>}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <a
                        href="javascript:void(0);"
                        onClick={this.handleSubmit}
                        className="btn save_btn mr-2"
                      >
                        {TypeOfEventID?"Update":"Save"}
                      </a>
                      <a
                        href="javascript:void(0);"
                        onClick={() => this.navigateBackEvent()}
                        className="btn back_btn"
                        id="cancel_co_applicant_pop"
                      >
                        Back
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
          <ToastContainer />
        </>
      </>
    );
  }
}

export default withRouter(
  connect(null, { event_add_action, event_detail_action })(EventsAdd)
);
